module.exports = __webpack_public_path__ + "static/img/gofun_logo.8192412.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gofun_logo.jpg
// module id = 56vI
// module chunks = 1